import { Button } from '@cast/design-system';

import { DialogFeedbackLayout } from './DialogFeedbackLayout';
import { DialogFeedbackMessage } from './DialogFeedbackMessage';

type FeedbackMessageSlideProps = {
  success: boolean;
  onContinue: () => void;
};

export const FeedbackMessageSlide = ({
  success,
  onContinue,
}: FeedbackMessageSlideProps) => {
  const variant = success ? 'success' : 'error';

  return (
    <DialogFeedbackLayout
      variant={variant}
      actions={
        <Button testId="feedback-close-button" onClick={onContinue}>
          Close
        </Button>
      }
    >
      <DialogFeedbackMessage
        variant={variant}
        title={success ? 'Great!' : 'Opps, something went wrong'}
        body={
          success
            ? 'Your trial version request has been received! All premium features will be available upon confirmation.'
            : `Please try again later`
        }
      />
    </DialogFeedbackLayout>
  );
};
